var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center",staticStyle:{"padding":".729167rem 0 0 2.1875rem"}},[_c('div',{staticClass:"cicon"}),_c('div',{staticClass:"label1"},[_vm._v(_vm._s(_vm._f("DateFormat")(_vm.date,"yyyy/MM/dd")))]),_c('div',{staticClass:"label2"},[_vm._v(_vm._s(_vm.weekday[_vm.date.getDay()]))])])
}
var staticRenderFns = []

export { render, staticRenderFns }